// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3BLnD","Button__Project":"Button_Button__Project__1j7ga","Button_blue3":"Button_Button_blue3__3KS42","Button__Text":"Button_Button__Text__1C0om"};